import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import { Faq16 } from '@cian/ui-kit/prev';

import { prepareRate } from '../../../../../containers/TransportAccessibilityRate/helpers';
import { CommonRateIndicator } from './parts/CommonRateIndicator';

import * as styles from './RateInfo.css';

export interface IRateInfoProps {
  rate: number;
}

export const RateInfo: React.FC<IRateInfoProps> = ({ rate }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['text']}>
        <UIText2 fontWeight="bold">Оценка от Дептранса</UIText2>
        <div className={styles['info-icon']}>
          <Faq16 color="primary_100" />
        </div>
        <div className={styles['rate']}>{prepareRate(rate)}</div>
      </div>
      <CommonRateIndicator rate={rate} />
    </div>
  );
};
